<template>
  <div>
    <div v-if="layout !== null && $store.state.websocket === true" class="container mt-4">
      <!-- Title -->
      <div class="row">
        <div class="col">
          <!-- Layout edit controls -->
          <div class="float-end" v-if="$store.state.user.level === 3">
            <div class="input-group">
              <button class="btn btn-primary" v-if="!editMode" @click="editMode = !editMode"><i class="fas fa-pen"></i> Muuda</button>
              <button class="btn btn-danger" v-if="editMode" @click="editMode = !editMode"><i class="fas fa-times"></i> Tühista</button>
              <button class="btn btn-success" v-if="editMode" @click="saveLayout"><i class="fas fa-save"></i> Salvesta muudatused</button>
            </div>
          </div>
          <h3>
            <router-link class="return-arrow" :to="'/view/station/' + $store.state.stations[0].id" v-if="$route.params.station_id !== $store.state.stations[0].id">
              <i class="far fa-arrow-alt-circle-left"></i>
            </router-link>
            {{ station.name }}
          </h3>
        </div>
      </div>
      <!-- Alerts -->
      <div v-for="serial in station.serials" :key="serial">
        <div class="alert alert-warning" v-if="$store.getters.device(serial).timestamp < time - timeoutLimit">
          Seadme {{ serial }} andmed ei ole ajakohased!<br>
          <small :title="$luxon($store.getters.device(serial).timestamp)">Viimane uuendus {{ $luxon($store.getters.device(serial).timestamp, 'relative') }}</small>
        </div>
      </div>
      <!-- View -->
      <div v-if="layout !== null" class="row g-2">
        <!-- Render view from layout conf -->
        <div v-for="(view, colIndex) in layout" :key="colIndex" :class="view.width">
          <div class="card">
            <div class="card-header" v-if="editMode">
              <div class="input-group">
                <button class="btn btn-sm btn-secondary" @click="moveCol(colIndex, -1)" v-if="colIndex !== 0">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <input class="form-control" v-model="view.width"/>
                <button class="btn btn-sm btn-danger" @click="removeCol(colIndex)">
                  <i class="fas fa-trash"></i>
                </button>
                <button class="btn btn-sm btn-secondary" @click="moveCol(colIndex, +1)" v-if="colIndex !== layout.length - 1">
                  <i class="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
            <div class="card-body p-2">
              <h4 v-if="view.title && !editMode">{{ view.title }}</h4>
              <input v-if="editMode" class="form-control" v-model="view.title">
              <div v-for="(component, itemIndex) in view.components" :key="itemIndex" class="itemDisplay" :class="{'hoverableItemDisplay': editMode}">
                <!-- Editor controls -->
                <div v-if="editMode" class="itemOptions float-end position-absolute" style="right: 0; z-index: 1000">
                  <div class="input-group">
                    <!-- Move up -->
                    <button class="btn btn-sm btn-secondary" @click="moveItem(colIndex, itemIndex, -1)" v-if="itemIndex !== 0">
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <!-- Edit -->
                    <button class="btn btn-sm btn-primary" @click="editItem(colIndex, itemIndex)">
                      <i class="fas fa-pen"></i>
                    </button>
                    <!-- Remove -->
                    <button class="btn btn-sm btn-danger" @click="removeItem(colIndex, itemIndex)">
                      <i class="fas fa-trash"></i>
                    </button>
                    <!-- Move down -->
                    <button class="btn btn-sm btn-secondary" @click="moveItem(colIndex, itemIndex, +1)" v-if="itemIndex !== view.components.length - 1">
                      <i class="fas fa-arrow-down"></i>
                    </button>
                  </div>
                </div>
                <!-- Component loader -->
                <!--
                <div v-if="component.extra && component.extra.serial">
                  AGE: {{ (time - $store.getters.device(component.extra.serial).timestamp) / 1000 }}
                </div>
                -->
                <component :title="component.title"
                           :station="station" :extra="component.extra" v-bind:is="component.type"
                           :sync="{ time: time, timeout: timeoutLimit }"
                           :class="{'component-offline': component.extra && $store.getters.device(component.extra.serial).timestamp < time - timeoutLimit, 'min-height': editMode}">
                </component>
              </div>
              <!-- Add item -->
              <div class="mt-2" v-if="editMode">
                <select class="form-select-sm float-end" v-model="addingItem" @change="addItem(colIndex)">
                  <option disabled selected value="null">Lisa komponent</option>
                  <option v-for="(component, index) in components" :value="index" :key="index">{{ component.type }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add column button -->
      <div class="row mt-4">
        <div class="col">
          <div class="float-end">
            <div class="input-group">
              <button class="btn btn-warning" @click="addCol" v-if="editMode"><i class="fas fa-plus"></i> Lisa tulp</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Debug data -->
      <div v-if="host !== 'pilv.app'" class="accordion mt-4" id="debug">
        <!-- Project config -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingZero">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseZero" aria-expanded="false" aria-controls="collapseZero">
              Project config
            </button>
          </h2>
          <div id="collapseZero" class="accordion-collapse collapse" aria-labelledby="headingZero" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <pre>
                {{ $store.state.project }}
              </pre>
            </div>
          </div>
        </div>
        <!-- Station config -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              Station config
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <pre>
                {{ station }}
              </pre>
            </div>
          </div>
        </div>
        <!-- Station layout -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Station layout
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <pre>
                {{ layout }}
              </pre>
            </div>
          </div>
        </div>
        <!-- Station devices -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              Station devices
            </button>
          </h2>
          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <pre v-for="device in station.serials" :key="device">
                <h6>
                  {{ device }} - {{ $luxon($store.getters.device(device).timestamp, 'relative') }} - {{ $luxon($store.getters.device(device).timestamp) }}
                </h6>
                {{ $store.getters.device(device) }}
              </pre>
            </div>
          </div>
        </div>
      </div>
      <!-- End debug data -->
    </div>
    <div v-else class="d-flex justify-content-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Item edit modal -->
    <div class="modal fade" ref="editModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div v-if="editingItem !== null" class="modal-content">
          <div class="modal-body">-
            <!-- Preview -->
            <div class="row mb-4">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <component v-if="editingItem.component.type !== 'MultiChart'" :title="editingItem.component.title"
                               :station="station" :extra="editingItem.component.extra" mode="editor" v-bind:is="editingItem.component.type">
                    </component>
                    <div v-else>MultiChart preview not supported</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Editor and device list -->
            <div class="row">
              <!-- JSON editor -->
              <div class="col">
                <JsonEditorVue v-model="editingItem.component"/>
              </div>
              <!-- Available devices -->
              <div class="col">
                <div class="accordion">
                  <!-- Project config -->
                  <div v-for="(device, index) in station.serials" :key="index" class="accordion-item">
                    <h2 class="accordion-header" :id="'heading-' + index">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-' + index" aria-expanded="false" :aria-controls="'collapse-' + index">
                        {{ device }}
                      </button>
                    </h2>
                    <div :id="'collapse-' + index" class="accordion-collapse collapse" :aria-labelledby="'heading-' + index" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <pre>
                          {{ $store.getters.device(device) }}
                        </pre>
                      </div>
                    </div>
                  </div>
                  <!-- -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Sulge</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveItem">Salvesta</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import components from '../store/components'
import { Modal } from 'bootstrap'
import Divider from '../components/UI/Divider.vue'
import Pump from '../components/UI/Pump'
import PumpStatus from '../components/UI/PumpStatus'
import Alarms from '../components/UI/Alarms'
import Tank from '../components/UI/Tank'
import Information from '../components/UI/Information'
import Stage1 from '../components/UI/Stage1'
import LineChart from '../components/UI/LineChart'
import OverflowPump from '../components/UI/OverflowPump'
import OverflowTank from '../components/UI/OverflowTank'
import SimpleData from '../components/UI/SimpleData'
import ResetButton from '../components/UI/ResetButton'
import Level from '../components/UI/Level'
import Config from '../components/UI/Config'
import ActionButton from '../components/UI/ActionButton'
import RunMode from '../components/UI/RunMode'
import BooleanIndicator from '../components/UI/BooleanIndicator'
import PeriodReport from '../components/UI/PeriodReport'
import DataChart from '../components/UI/DataChart'
import LinkButton from '../components/UI/LinkButton'
import ChartModal from '../components/UI/ChartModal'
import ControlButton from '../components/UI/ControlButton'
import StartScheduler from '../components/UI/StartScheduler'
import StartStopScheduler from '../components/UI/StartStopScheduler'
import MultiChart from '../components/UI/MultiChart'
import OverviewMap from '../components/UI/OverviewMap'
import DataIcons from '../components/UI/DataIcons.vue'
import FlowChart from '../components/UI/FlowChart.vue'

export default {
  components: {
    components,
    Divider,
    Tank,
    Pump,
    PumpStatus,
    Alarms,
    Information,
    Stage1,
    LineChart,
    OverflowPump,
    OverflowTank,
    SimpleData,
    ResetButton,
    Level,
    Config,
    ActionButton,
    RunMode,
    BooleanIndicator,
    PeriodReport,
    DataChart,
    LinkButton,
    ChartModal,
    ControlButton,
    StartScheduler,
    StartStopScheduler,
    MultiChart,
    OverviewMap,
    DataIcons,
    FlowChart
  },
  metaInfo () {
    return {
      title: this.station.name
    }
  },
  data () {
    return {
      station: {
        name: '-'
      },
      layout: null,
      layoutBackup: null,
      host: location.host,
      editMode: false,
      editModal: null,
      editingItem: null,
      addingItem: null,
      components: null,
      time: Date.now(),
      timeInterval: null,
      timeoutLimit: 300000
    }
  },
  watch: {
    '$route.params.station_id': function () {
      this.getStation()
    },
    '$store.state.project': function () {
      this.getStation()
    },
    editMode: function (newValue, oldValue) {
      if (newValue) {
        // this.layoutBackup = this.layout
      }
    }
  },
  sockets: {
    connect: function () {
      this.subscribe()
    },
    data: function (data) {
      this.$store.commit('updateData', data)
    },
    updateConfig: function (data) {
      // console.log('updateConfig res:', data)
    }
  },
  mounted () {
    const _this = this
    this.editModal = new Modal(this.$refs.editModal)
    this.editModal.hide()
    this.components = components.list
    // Start incrementing time interval
    this.timeInterval = setInterval(() => {
      _this.time = Date.now()
    }, 1000)
  },
  created () {
    if (this.$store.state.project === null) {
      console.log('Selected project:', this.$store.state.project)
      console.log('Setting project to:', this.$route.params.station_id.split('_')[0])
      this.$socket.emit('setProject', this.$route.params.station_id.split('_')[0])
      this.getStation()
      // this.$router.push('/')
    } else {
      console.log('Project was already set, loading station')
      this.getStation()
    }
  },
  beforeDestroy () {
    clearInterval(this.timeInterval)
  },
  methods: {
    // Get station info from local data
    getStation () {
      // Fetch local station data from memory
      this.station = this.$store.state.stations.find(station => station.id === this.$route.params.station_id)

      // Subscribe to station serials
      this.subscribe()

      const _this = this

      // Fetch layout from server
      axios.get(this.$store.getters.apiUrl + '/layouts?id=' + this.$route.params.station_id)
        .then(function (response) {
          console.log('Station layout config:', response.data)
          _this.layout = response.data
        })
        .catch(function (error) {
          console.log('Failed to fetch station layout config:', error)
        })

      // Set station timeout based on config, if available
      if (this.station.timeout) {
        this.timeoutLimit = this.station.timeout
      }
    },
    // Request station socket rooms
    subscribe () {
      // console.log('subscribed to', this.station.serials)
      this.$socket.emit('requestRooms', this.station.serials)
      // Request station alarms
      // console.log('Requesting alarmlog for group_id: ' + this.station.alarm_group_id)
      // this.$socket.emit('alarmLog', { group_id: this.station.alarm_group_id })
    },
    // Add column in view
    addCol () {
      this.layout.push({ width: 'col-6', components: [] })
    },
    // Move column position in view
    moveCol (oldIndex, direction) {
      this.layout.splice((direction === -1) ? oldIndex - 1 : oldIndex + 1, 0, this.layout.splice(oldIndex, 1)[0])
    },
    // Remove column from layout
    removeCol (colIndex) {
      this.layout.splice(colIndex, 1)
    },
    // Add item in column
    addItem (colIndex) {
      this.layout[colIndex].components.push(this.components[this.addingItem])
      this.editItem(colIndex, this.layout[colIndex].components.length - 1)
      this.addingItem = null
    },
    // Move item position in column
    moveItem (colIndex, itemIndex, direction) {
      const arr = this.layout[colIndex].components
      arr.splice((direction === -1) ? itemIndex - 1 : itemIndex + 1, 0, arr.splice(itemIndex, 1)[0])
    },
    // Remove item from column
    removeItem (colIndex, itemIndex) {
      this.layout[colIndex].components.splice(itemIndex, 1)
    },
    // Edit item
    editItem (colIndex, itemIndex) {
      this.editingItem = { col: colIndex, item: itemIndex, component: this.layout[colIndex].components[itemIndex] }
      this.editModal.show()
    },
    // Save edited item
    saveItem () {
      this.layout[this.editingItem.col].components[this.editingItem.item] = this.editingItem.component
      this.editingItem = null
      this.editModal.hide()
    },
    // Save layout
    saveLayout () {
      const data = { name: this.$route.params.station_id, config: this.layout }
      this.$socket.emit('updateConfig', data)
      this.editMode = false
      // console.log('updateConfig req:', data)
    }
  }
}
</script>

<style>
.return-arrow {
  color: #2c3034;
  opacity: 0.8;
}
.hoverableItemDisplay:hover {
  background-color: pink;
  transition-duration: 500ms;
}
.itemDisplay:hover .itemOptions, .itemOptions:hover {
  opacity: 1;
}
.itemOptions {
  transition-duration: 500ms;
  opacity: 0;
}
.min-height {
  min-height: 10px;
  border: 1px dashed palevioletred;
}
</style>
